import { getRestApiRoot } from '../basePath';

const restRoot = getRestApiRoot();

export interface SendMutationOptions {
  noPrefix?: boolean;
  credentials?: RequestCredentials;
}

export type SendMutationErrorInfo = 'FETCH_THROWED' | 'WRONG_STATUS';

export interface SendMutationSuccess {
  error: false;
  statusCode: 200 | 202;
  body: unknown;
}

export interface SendMutationFetchError {
  error: true;
  errorInfo: 'FETCH_THROWED';
  statusCode: null;
  body: unknown;
}

export interface SendMutationStatusError {
  error: true;
  errorInfo: 'WRONG_STATUS';
  statusCode: number;
  body: unknown;
}

export type SendMutationResult =
  | SendMutationSuccess
  | SendMutationFetchError
  | SendMutationStatusError;

/**
 * REST fetch which returns whether the call succeeded and the parsed response body.
 */
async function sendMutation(
  method: string,
  query: string,
  payload?: FormData | Record<string, unknown> | null,
  options?: SendMutationOptions
): Promise<SendMutationResult> {
  let response: Response;
  try {
    let body: BodyInit | undefined;
    const headers: Record<string, string> = {
      Accept: 'application/json',
    };
    if (payload instanceof FormData) {
      body = payload;
    } else if (payload != null) {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }
    const url = options?.noPrefix ? query : `${restRoot}${query}`;
    const init: RequestInit = {
      headers,
      method: method.toUpperCase(),
      body,
    };
    if (options?.credentials) {
      init.credentials = options.credentials;
    }
    response = await fetch(url, init);
  } catch (e) {
    // oxlint-disable-next-line no-console
    console.log(`${query} ${method} Fetch throwed: `, e);
    return {
      error: true,
      errorInfo: 'FETCH_THROWED',
      statusCode: null,
      body: e,
    };
  }

  let json: unknown = null;
  try {
    json = await response.json();
  } catch {
    json = null;
  }

  const { status } = response;
  if (status === 200 || status === 202) {
    return {
      error: false,
      statusCode: status,
      body: json,
    };
  }

  // oxlint-disable-next-line no-console
  console.log(`${query} ${method} Response received status code: ${status}`);
  return {
    error: true,
    errorInfo: 'WRONG_STATUS',
    statusCode: status,
    body: json,
  };
}

export default sendMutation;
